<template>

  <div class="p-grid">
    <div :style="expandSidebarDialog ? 'width:70rem;' : 'width:20rem;'"
         style="margin: 10px;box-shadow: 1px 1px 1px lightgrey; font-size: 12px; background: #fff">
      <div style="padding-right: 1.5rem;padding-top: 1.5rem;padding-left: 1.5rem;">
        <h3 class="p-m-0" style="line-height: .9">
          <Button
              v-tooltip="expandSidebarDialog ? _t('label_List_view') : _t('label_Table_view')"
              :icon="expandSidebarDialog ? 'mdi mdi-table-arrow-left' : 'mdi mdi-table-arrow-right'"
              class="p-button-rounded p-button-icon-only p-button-text"
              style="float: right;"
              @click="expandSidebarDialog = !expandSidebarDialog"
          />
          <Button v-tooltip.bottom="'Create new timer'"
                  class="p-button-rounded p-button-success p-button-text"
                  icon="pi pi-plus" style="float: right;" @click="isNewTimerDialogOpen = true;"/>
          <strong>Alarm timer</strong>
        </h3>
        <br>
        <MultiSelectableBreadcrumb ref="breadcrumbData" :tree-params="treeParams"
                                   single-selection></MultiSelectableBreadcrumb>
        <div style="display: flex; flex-direction: row; align-items: center; width: 100%;">
          <span :style="`${expandSidebarDialog ? 'width:100%;' : 'width:100%; margin-left: 0px;'}` + 'padding: 12px 0;'"
                class="p-input-icon-right">
            <i class="pi pi-search" style="font-size: 12px;"/>
            <InputText v-model="alarmTimersSearch" style="width:100%;" type="text"/>
          </span>
        </div>
      </div>
      <DataTable
          ref="tree"
          v-model:selection="selectedAlarmTimer"
          :dataKey="tableDataKey"
          state-key="alarmPointId"
          :lazy="true"
          :page="atCurrentPage"
          :paginator="true"
          :paginatorTemplate="'FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink'"
          :rowHover="true"
          :rows="alarmTimerRows"
          :scrollable="true"
          :totalRecords="atTotalRecords"
          :value="alarmTimers"
          class="tight"
          scrollHeight="72vh"
          selectionMode="single"
          stripedRows
          @page="selectTablePage($event)"
          @row-click="selectAlarmTimer($event.data);"
      >
        <Column
            :header="_t('Name')"
            :style="'width:' + (100 / alarmTimers?.length) + '%; word-break: break-all; min-height: 38px;'"
            field="alarmPointId"
        >
          <template #body="slotProps">
             <span v-tooltip.bottom="slotProps.field"
                   style="padding-left: 5px; word-break: break-all;"
                   class="wrap"
             >
                {{
                 slotProps.data.alarmPointId
               }}
          </span>
          </template>
        </Column>

        <Column
            v-if="expandSidebarDialog"
            header="ID"
            :style="'width:' + (100 / alarmTimers.length) + '%; word-break: break-all; min-height: 38px;'"
            field="id"
        >
          <template #body="slotProps">
            <span
                style="padding-left: 5px; word-break: break-all;"
            >
              {{ slotProps.data.id }}
            </span>

          </template>
        </Column>

        <Column
            v-if="expandSidebarDialog"
            header="Created"
            :style="'width:' + (100 / alarmTimers.length) + '%; word-break: break-all; min-height: 38px;'"
            field="created"
        >
          <template #body="slotProps">
            <span
                style="padding-left: 5px; word-break: break-all;"
            >
              {{ slotProps.data.created }}
            </span>

          </template>
        </Column>

        <Column
            v-if="expandSidebarDialog"
            header="System ID"
            :style="'width:' + (100 / alarmTimers.length) + '%; word-break: break-all; min-height: 38px;'"
            field="systemId"
        >
          <template #body="slotProps">
            <span
                style="padding-left: 5px; word-break: break-all; width: max-content;"
            >
              {{ slotProps.data.systemId }}
            </span>

          </template>
        </Column>
      </DataTable>
    </div>

    <singleTimer :item="selectedTimer" @callAlarmTimers="getAlarmTimersList()"/>
  </div>

  <Toast/>

  <Dialog v-model:visible="isNewTimerDialogOpen"
          :style="`${newTimerType === 'custom' && 'width: 600px'}`"
          :autoZIndex="false"
          style="z-index: 1000;"
          @close="isNewTimerDialogOpen = false"
          modal>
    <template #header>
      <h3>New alarm timer</h3>
    </template>

    <div v-if="!newTimerType" class="cards-wrapper">
      <div
          v-for="(card, index) in cards"
          :key="index"
          class="card-wrapper"
          @click="chooseTimerType(card.variant)"
      >
        <div class="card-content">
          <i :class="`icon mdi mdi-${card.icon}`" style="font-size: 18px;"></i>
          <p style="font-size: 18px!important; margin-top: 1rem; color: #82B541;">{{ card.title }}</p>
          <p>{{ card.description }}</p>
        </div>
      </div>
    </div>

    <div style="display: flex; flex-direction: column; gap: 1.5rem;">
      <span style="text-align: center;">
        <strong v-if="newTimerType === 'single'" style="font-size: 16px;">One-time timer</strong>
        <strong v-if="newTimerType === 'custom'" style="font-size: 16px;">Custom timer</strong>
      </span>

      <div v-if="newTimerType === 'single'" style="display: flex; flex-direction: column;">
        <div style="display: flex; align-items: flex-start; justify-content: space-between; width: 100%; gap: 12px;">
          <div
              style="display: flex; flex-direction: column; justify-content: center; align-items: flex-start; gap: 12px; width: 100%;">
            <label for="alarmPoint" style="margin-bottom: -10px;">Assign to</label>
            <Dropdown
                v-model="selectedAlarmPoint"
                id="alarmPoint"
                :options="alarmPoints"
                optionLabel="name"
                optionValue="name"
                placeholder="Select alarmpoint"
                style="width: 100%; align-items: center;"
                @show="onDropdownShow"
                @hide="onDropdownHide"
                :loading="loading"
                filter
            />
            <label for="calendar-24h" style="margin-bottom: -10px;">Run at</label>
            <Calendar id="calendar-24h"
                      ref="calendarRef"
                      v-model="datetime24h"
                      placeholder="Select date and time"
                      hourFormat="24"
                      date-format="d/m/yy"
                      style="width: 30rem;"
                      @monthChange="updateMonth"
                      @yearChange="updateYear"
                      :minDate="minDate"
                      showTime/>
          </div>
        </div>
      </div>
      <div v-if="newTimerType === 'custom'">
        <div class="p-grid" style="margin-bottom: 7px;">
          <div class="p-col-4 stripedBg" style="display: flex; align-items: center;">
            <p>Assign to<sup>*</sup></p>
          </div>
          <div class="p-col-8 stripedBg" style="vertical-align: middle;">
            <Dropdown
                v-model="selectedAlarmPoint"
                id="alarmPoint"
                :options="alarmPoints"
                optionLabel="name"
                optionValue="name"
                placeholder="Select alarmpoint"
                @show="onDropdownShow"
                @hide="onDropdownHide"
                style="height: 30px; width: 100%;"
                :loading="loading"
                filter
            />
          </div>
        </div>
        <CronEditor ref="cronEditorRef" :selectedAlarmPoint="selectedAlarmPoint"/>
      </div>
      <div v-if="newTimerType" style="display: flex; justify-content: space-between; width: 100%;">
        <Button label="Back to timers selection" class="p-button-outlined p-button-secondary"
                @click="clearNewTimerForm"/>
        <Button
            label="Create timer" class="p-button-success" @click="createTimer"/>
      </div>
    </div>
  </Dialog>
</template>

<script>
import {getList} from '@/api/list'
import {getAlarmTimers} from "@/api/alarmTimer";
import singleTimer from './item.vue'
import CronEditor from "@/components/CronEditor.vue";
import MultiSelectableBreadcrumb from "@/components/ixarma/MultiSelectableBreadcrumb.vue";
import Dropdown from "primevue/dropdown";

export default {
  name: 'general-alarm-timer',
  components: {
    Dropdown,
    MultiSelectableBreadcrumb,
    singleTimer,
    CronEditor,
  },
  data() {
    return {
      selectedTimer: {
        id: this.$route.params.id || null,
        cron: null,
        icon: {
          name: '',
          color: ''
        }
      },
      orgId: localStorage.getItem('orgId') ?? 1,
      alarmPointSearch: '',
      alarmTimersSearch: '',
      alarmPoints: null,
      alarmTimers: null,
      selectedAlarmTimer: null,
      selectedDateInterval: null,
      selectedAlarmPoint: null,
      dateIntervals: [
        {label: 'Daily', value: 'daily'},
        {label: 'Weekly', value: 'weekly'},
        {label: 'Monthly', value: 'monthly'},
        {label: 'Ordinal', value: 'ordinal'},
      ],
      hourOptions: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
      selectedHour: '*',
      selectedMinute: '*',
      selectedMonth: '*',
      selectedDay: '*',
      now: new Date(),
      months: [
        {label: 'January', value: 'JANUARY'},
        {label: 'February', value: 'FEBRUARY'},
        {label: 'March', value: 'MARCH'},
        {label: 'April', value: 'APRIL'},
        {label: 'May', value: 'MAY'},
        {label: 'June', value: 'JUNE'},
        {label: 'July', value: 'JULY'},
        {label: 'August', value: 'AUGUST'},
        {label: 'September', value: 'SEPTEMBER'},
        {label: 'October', value: 'OCTOBER'},
        {label: 'November', value: 'NOVEMBER'},
        {label: 'December', value: 'DECEMBER'},
      ],
      days: [
        {label: 'Monday', value: 'MONDAY'},
        {label: 'Tuesday', value: 'TUESDAY'},
        {label: 'Wednesday', value: 'WEDNESDAY'},
        {label: 'Thursday', value: 'THURSDAY'},
        {label: 'Friday', value: 'FRIDAY'},
        {label: 'Saturday', value: 'SATURDAY'},
        {label: 'Sunday', value: 'SUNDAY'},
      ],
      daysNumbers: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
      expandSidebarDialog: false,
      isNewTimerDialogOpen: false,
      tabs: [
        {label: 'Daily', value: 'daily'},
        {label: 'Weekly', value: 'weekly'},
        {label: 'Monthly', value: 'monthly'},
        {label: 'Ordinal', value: 'ordinal'},
      ],
      selectorIsLoading: false,
      tableDataKey: null,
      currentPage: 0,
      atCurrentPage: 0,
      apCurrentPage: 0,
      totalRecords: 0,
      atTotalRecords: 0,
      alarmTimerRows: 100,
      dropdownScrollElement: null,
      loading: false,
      cards: [
        {
          icon: 'timer-outline',
          title: 'One time timer',
          description: 'Simple timer by date and time',
          variant: 'single',
        },
        {
          icon: 'timer-cog-outline',
          title: 'Custom timer',
          description: 'Timer with custom settings',
          variant: 'custom',
        },
      ],
      newTimerType: '',
      newTimerForm: {
        selectedYear: '*',
        selectedMonth: '*',
        selectedDay: '*',
        selectedHour: '*',
        selectedMinute: '*',
      },
      datetime24h: null,
      treeParams: '',
      minDate: new Date(),
    }
  },
  async mounted() {
    await Promise.all([
      this.getAlarmPoints(),
      this.getAlarmTimersList()
    ]).then(() => {
      if (this.$route.params.id) {
        this.selectedTimer = this.alarmTimers.find((element) => element.id === this.$route.params.id);
      }
    });

    this.updateDateTime();
  },
  watch: {
    isNewTimerDialogOpen(value) {
      if (!value) {
        this.cleanModal();
        this.newTimerType = '';
        this.selectedDateInterval = null;
      }
    },
    datetime24h(newVal) {
      this.updateDateTime();

      if (!newVal) return;

      const now = new Date();

      const isSameDate =
          newVal.getFullYear() === now.getFullYear() &&
          newVal.getMonth() === now.getMonth() &&
          newVal.getDate() === now.getDate();

      if (isSameDate) {
        const selectedHours = newVal.getHours();
        const selectedMinutes = newVal.getMinutes();

        const currentHours = now.getHours();
        const currentMinutes = now.getMinutes();

        if (
            selectedHours < currentHours ||
            (selectedHours === currentHours && selectedMinutes < currentMinutes)
        ) {
          const updated = new Date(newVal);
          updated.setHours(currentHours);
          updated.setMinutes(currentMinutes);
          this.datetime24h = updated;
        }
      }
    },
  },
  methods: {
    generateCronExpression() {
      const {
        selectedYear,
        selectedMonth,
        selectedDay,
        selectedHour,
        selectedMinute,
      } = this.newTimerForm;

      return `* ${selectedMinute} ${selectedHour} ${selectedDay} ${+selectedMonth} ${selectedYear}`;
    },
    clearNewTimerForm() {
      this.newTimerType = '';
      this.newTimerForm = {
        selectedYear: null,
        selectedMonth: null,
        selectedDay: null,
        selectedHour: null,
        selectedMinute: null,
      };
      this.selectedAlarmPoint = null;
      this.datetime24h = null;
    },
    onDropdownShow() {
      this.$nextTick(() => {
        const el = document.querySelector('.p-dropdown-panel .p-dropdown-items-wrapper');
        if (el) {
          this.dropdownScrollElement = el;
          el.addEventListener('scroll', this.handleDropdownScroll);
        }

        if (this.alarmPoints.length === 0) {
          this.getAlarmPoints();
        }
      });
    },
    onDropdownHide() {
      if (this.dropdownScrollElement) {
        this.dropdownScrollElement.removeEventListener('scroll', this.handleDropdownScroll);
        this.dropdownScrollElement = null;
      }
    },
    handleDropdownScroll(event) {
      const el = event.target;
      const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 10;

      if (nearBottom && !this.loading) {
        this.apCurrentPage = this.apCurrentPage + 1;
        this.getAlarmPoints('', true);
      }
    },
    cleanModal() {
      this.selectedAlarmPoint = null;
      this.selectedMonth = null;
      this.selectedDay = null;
      this.selectedHour = null;
      this.selectedMinute = null;
      this.datetime24h = new Date()
    },
    getAlarmTimersList() {
      this.alarmTimers = [];
      return getAlarmTimers().then((res) => {
        this.alarmTimers = res.data;
      })
    },
    selectTablePage(item) {
      this.apCurrentPage = item.page
    },
    selectAlarmTimer(data) {
      this.$router.push({
        params: {
          id: data.id
        },
        query: this.$route.query
      });

      this.selectedTimer = data;
    },
    createTimer() {
      if (this.newTimerType === 'single') {
        this.selectedAlarmPoint.length && this.$toast.add({
          severity: "success",
          summary: this._t("SUCCESS"),
          detail: this.generateCronExpression(),
          life: 5000,
        });
      }

      if (this.newTimerType === 'custom') {
        this.selectedAlarmPoint.length && this.$toast.add({
          severity: "success",
          summary: this._t("SUCCESS"),
          detail: this.$refs.cronEditorRef.getCronString(),
          life: 5000,
        });
      }
    },
    getAlarmPoints($filter = '', isScrolling = false) {
      this.alarmPointSearch = $filter
      this.loading = true;
      return getList('ALARMPOINT', this.apCurrentPage, this.alarmPointSearch, 20, this.orgId).then((response) => {
        if (!isScrolling) {
          this.alarmPoints = []
          this.alarmPoints = response.data.list;
          this.alarmPoints.sort((a, b) => a.name.localeCompare(b.name));
        } else {
          const result = [...this.alarmPoints, ...response.data.list];
          this.alarmPoints = result;
          this.alarmPoints.sort((a, b) => a.name.localeCompare(b.name));
        }

        this.loading = false;
      })
    },
    chooseTimerType(variant) {
      this.newTimerType = variant;
    },
    pad(value) {
      return value.toString().padStart(2, '0');
    },
    updateDateTime() {
      const date = this.datetime24h;
      if (!date) return null;

      this.newTimerForm.selectedYear = date.getFullYear().toString();
      this.newTimerForm.selectedMonth = this.pad(date.getMonth() + 1);
      this.newTimerForm.selectedDay = this.pad(date.getDate());
      this.newTimerForm.selectedHour = this.pad(date.getHours());
      this.newTimerForm.selectedMinute = this.pad(date.getMinutes());
    },
    updateMonth(date) {
      const result = new Date(this.datetime24h || new Date());

      const currentMonth = new Date().getMonth() + 1;
      const selectedMonth = date.month;

      const finalMonth = selectedMonth < currentMonth ? currentMonth : selectedMonth;

      result.setMonth(finalMonth - 1);
      this.datetime24h = result;
    },
    updateYear(date) {
      const now = new Date();
      const result = new Date(this.datetime24h || now);

      const selectedYear = date.year;
      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth();

      if (selectedYear < currentYear) {
        result.setFullYear(currentYear);

        if (result.getMonth() < currentMonth) {
          result.setMonth(currentMonth);
        }
      } else {
        result.setFullYear(selectedYear);
      }

      this.datetime24h = result;
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep(.p-datatable) {
  .p-datatable-header {
    padding: 10px;
    text-align: left;
    font-size: 1.5rem;
  }

  .p-paginator {
    padding: 10px;
  }

  .p-datatable-thead > tr > th {
    text-align: left;
    padding: 10px;
    background-color: #f8f9fa;
    padding-left: 10px !important;
  }

  .p-datatable-tbody > tr > td {
    cursor: auto;
    padding: 5px;
    font-weight: 1500;
  }

  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}

::v-deep(.p-multiselect-label) {
  font-size: 12px !important;
  font-family: Roboto, Helvetica Neue Light, Helvetica Neue, Helvetica, Arial, Lucida Grande, sans-serif !important;
}

.p-multiselect {
  font-family: Roboto, Helvetica Neue Light, Helvetica Neue, Helvetica, Arial, Lucida Grande, sans-serif;
}

::v-deep(.p-card-body) {
  padding-top: 0;
}

.cards-wrapper {
  display: flex;
  justify-content: center;
  gap: 3rem;
  padding: 1rem;
  overflow-x: auto;
}

.card-wrapper {
  position: relative;
  min-width: 250px;
  padding: 1.5rem;
  border-radius: 1rem;
  background-color: #f0f4f8;
  color: #333;
  text-align: center;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  overflow: hidden;
  cursor: pointer;
}

.card-wrapper:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
}

.card-content .icon {
  font-size: 4rem !important;
  margin-bottom: 0.5rem;
}
</style>